module.exports = __webpack_public_path__ + "static/media/Collapse Blue.45f9a0f6.svg";